import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-appearance',
  templateUrl: './header-column-appearance.component.html',
  styleUrls: ['./header-column-appearance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnAppearanceComponent extends HeaderColumnComponent {}
